import React, { Fragment } from "react";

import { EditItem } from "./components/EditItem";

interface Props {
  name: string[];
  currency: string;
}

export const EditInline: React.FC<Props> = ({ name, currency }) => {
  return (
    <Fragment>
      {/* Pallet Row  */}
      <EditItem name={name} label="Pallets" inputKey="pallet" currency={currency} />
      {/* Shelf Row  */}
      <EditItem name={name} label="Shelves" inputKey="shelf" currency={currency} />
      {/* Bin Row  */}
      <EditItem name={name} label="Bins" inputKey="bin" currency={currency} />
      {/* Half Bin Row  */}
      <EditItem name={name} label="Half Bins" inputKey="halfBin" currency={currency} />
    </Fragment>
  );
};
